import { createContext } from 'react';
import type { TAuthenticationContextValue } from './Authentication.types.ts';

export const AuthenticationContext = createContext<
  TAuthenticationContextValue | undefined
>(undefined);
